import {
  Badge,
  Box,
  Grid,
  Toolbar,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { CustomAppBar } from "./style";
import {
  ElevationScroll,
  Logo,
  MobileNavToggler,
  NavBottomSpace,
  NavbarLink,
  Profiler,
  ScrollTop,
} from "./navbarComponents";
import { Link, useLocation, useParams } from "react-router-dom";
import { mainNavLinks } from "common/websiteData";
import { BookCourtButtonUI, CartButtonUI } from "components/button/ButtonUI";
import CartIcon from "assets/icons/CartIcon";
import { CONFIG } from "config";
import { useSelector } from "react-redux";
const Navbar = (props) => {
  const { isAuthenticated } = useSelector((store) => store.auth);
  const { pathname } = useLocation();
  const { planId, dropInId, courtId } = useParams();
  const theme = useTheme();
  const viewLG = useMediaQuery(theme.breakpoints.down("xl"));
  return (
    <>
      <span id="back-to-top-anchor" />
      <ElevationScroll {...props}>
        <CustomAppBar>
          <Toolbar
            sx={{
              minHeight: { xs: 80, sm: 56 },
              justifyContent: "space-between",
            }}
          >
            {viewLG && <MobileNavToggler />}
            <Box
              component={Link}
              position={{ xs: "absolute", sm: "relative" }}
              left={{ xs: "50%", sm: 10 }}
              top={{ xs: "50%", sm: "unset" }}
              ml={{ xs: "auto", lg: 0 }}
              mr={{ xs: "auto", lg: 0 }}
              sx={{ transform: { xs: "translate(-50%, -50%)", sm: "none" } }}
              to="/"
            >
              <Logo />
            </Box>
            {!viewLG && (
              <Grid
                width="auto"
                container
                columnSpacing={2.5}
                justifyContent="center"
              >
                {mainNavLinks?.map(({ id, href, label, rel, target }) => (
                  <Grid item key={id}>
                    <NavbarLink
                      href={href}
                      label={label}
                      rel={rel || ""}
                      target={target || ""}
                    />
                  </Grid>
                ))}
              </Grid>
            )}
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"end"}
              columnGap={1.5}
              width={
                !isAuthenticated ? "auto" : { xs: "auto", sm: 148, xl: 162 }
              }
            >
              <Profiler />
            </Box>
          </Toolbar>
        </CustomAppBar>
      </ElevationScroll>
      <ScrollTop {...props} />
      {![
        "/book-court",
        `/book-court/${courtId}`,
        "/private-team-lessons",
        `/private-team-lessons/${planId}`,
        "/drop-in",
        `/drop-in/${dropInId}`,
        "/school-fund-raising-program",
        "/badminton-beginners-programs",
        "/pa-day",
        "/winter-camp",
      ].includes(pathname) && (
        <>
          {!CONFIG.forbidden_routes.layout.book_court && (
            <BookCourtButtonUI
              component={Link}
              to="/book-court"
              variant="contained"
              color="info"
            >
              Book a Court Now
            </BookCourtButtonUI>
          )}
          {!CONFIG.forbidden_routes.layout.shop && (
            <CartButtonUI
              size="large"
              component={Link}
              rel="noopener noreferrer"
              to="https://royalproshop.com/"
              target="_blank"
            >
              <Badge badgeContent={1} color="error">
                <CartIcon size={24} />
              </Badge>
            </CartButtonUI>
          )}
        </>
      )}
      <NavBottomSpace />
    </>
  );
};

export default Navbar;
